module.exports = __webpack_public_path__ + "img/affiliate_platinum_card.c2d335a7.png";